import React, { useEffect } from 'react';
import Container from '@mui/material/Container';

import { utilities } from '~/common';
import { CoursePreviewProps, CourseTestimonialProps } from '~/components';

import type { SetVideoPlayerType } from '../SetVideoPlayerType';

import { CoursePreviews } from './CoursePreviews';
import { CourseTestimonials } from './CourseTestimonials';
import { AboutCourseMain, AboutCourseWrapper } from './elements';

const { scrollToElement, customHTMLTagsParser } = utilities;

interface AboutCourseProps {
  sections: {
    body: string;
    id: string;
  }[];
  setVideoPlayer: SetVideoPlayerType;
}

export const AboutCourse: React.FC<AboutCourseProps> = ({ sections, setVideoPlayer }) => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash !== '') {
      scrollToElement(document.getElementById(hash.slice(1, hash.length)));
    }
  }, []);

  return (
    <AboutCourseMain>
      <AboutCourseWrapper>
        <Container style={{ paddingTop: '40px' }}>
          <>
            {sections?.length &&
              sections[0] &&
              customHTMLTagsParser(sections[0].body, ['CoursePreview', 'CourseTestimonial']).map(
                section =>
                  section.type === 'html' ? (
                    <div
                      key={section.type}
                      dangerouslySetInnerHTML={{
                        __html: section.data,
                      }}
                    />
                  ) : section.type === 'CoursePreview' ? (
                    <CoursePreviews
                      setVideoPlayer={setVideoPlayer}
                      previews={JSON.parse(section.data) as CoursePreviewProps}
                    />
                  ) : section.type === 'CourseTestimonial' ? (
                    <CourseTestimonials
                      testimonials={JSON.parse(section.data) as CourseTestimonialProps}
                    />
                  ) : null,
              )}
          </>
        </Container>
      </AboutCourseWrapper>
    </AboutCourseMain>
  );
};
